import * as React from 'react';

export const onKeyPress = <T = any>({
  e,
  onConfirm,
  onClose,
  onNext,
  onPrevious,
  onMoveLeft,
  onMoveUp,
  onMoveRight,
  onMoveDown,
}: {
  e: React.KeyboardEvent;
  onConfirm?: () => T;
  onClose?: () => T;
  onNext?: () => T;
  onPrevious?: () => T;
  onMoveLeft?: () => T;
  onMoveUp?: () => T;
  onMoveRight?: () => T;
  onMoveDown?: () => T;
}) => {
  if (e.key === 'Enter' || e.key === ' ') {
    return onConfirm?.();
  }
  if (e.key === 'Escape') {
    return onClose?.();
  }
  if (e.shiftKey && e.key === 'Tab') {
    return onPrevious?.();
  }
  if (e.key === 'Tab') {
    return onNext?.();
  }
  if (e.key === 'ArrowLeft') {
    return onMoveLeft?.();
  }
  if (e.key === 'ArrowUp') {
    return onMoveUp?.();
  }
  if (e.key === 'ArrowRight') {
    return onMoveRight?.();
  }
  if (e.key === 'ArrowDown') {
    return onMoveDown?.();
  }
};
